/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FixedWingEligibleCrewResponse } from '../../models/fixed-wing-eligible-crew-response';

export interface ListFixedWingEligibleCrew$Params {
  date: string;
}

export function listFixedWingEligibleCrew(http: HttpClient, rootUrl: string, params: ListFixedWingEligibleCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<FixedWingEligibleCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, listFixedWingEligibleCrew.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FixedWingEligibleCrewResponse>;
    })
  );
}

listFixedWingEligibleCrew.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/eligible-crew';
